const baseUri = 'https://www.reed.co.uk/api/1.0/';
// My own proxy server to handle CORS blockage issues
// (using cors anywhere by Rob Wu)
export const proxyServer = 'https://jau-cors-anywhere-reed.herokuapp.com/';
export const apiKey = 'cdf3a52c-c542-43fb-b343-972714ae2e4f';

export default baseUri;
